"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.circleBoundsToCoveringCells = exports.shapeCellIdsToCovererCellIds = exports.boundsCellLatLngsToCoveringCells = void 0;
const iotv_v3_types_1 = require("@iotv/iotv-v3-types");
const nodes2ts_1 = require("nodes2ts");
const turf_1 = require("@turf/turf");
const S1ChordAngle_1 = require("nodes2ts/dist/S1ChordAngle");
const TurfUtils_1 = require("../TurfUtils");
/** this is taken from UI src/GoogleMapV4/mapfns/conversion.ts and de-googleized*/
const debug = process.env.REACT_APP_DEBUG && false;
/** returns cells filling rectangle bounds */
const boundsCellLatLngsToCoveringCells = ({ boundsLatLng, maxCells, maxLevel, minLevel }) => {
    const s2LatLngNE = nodes2ts_1.S2LatLng.fromDegrees(boundsLatLng.ne.lat, boundsLatLng.ne.lng);
    const cell1 = nodes2ts_1.S2Cell.fromLatLng(s2LatLngNE);
    const s2LatLng2SW = nodes2ts_1.S2LatLng.fromDegrees(boundsLatLng.sw.lat, boundsLatLng.sw.lng);
    const cell2 = nodes2ts_1.S2Cell.fromLatLng(s2LatLng2SW);
    const s2Cells = [cell1, cell2];
    return (0, exports.shapeCellIdsToCovererCellIds)({ s2Cells, maxCells, maxLevel, minLevel });
};
exports.boundsCellLatLngsToCoveringCells = boundsCellLatLngsToCoveringCells;
const shapeCellIdsToCovererCellIds = ({ s2Cells, maxCells, maxLevel, minLevel }) => {
    debug && console.log(`shapeCellIdsToCovererCellIds got `, { maxLevel, minLevel });
    const cellIds = s2Cells.map((cell) => cell.id.id);
    const union = new nodes2ts_1.S2CellUnion();
    union.initFromIds(cellIds);
    const bounds = union.getRectBound();
    const unionCoverer = new nodes2ts_1.S2RegionCoverer();
    maxCells && unionCoverer.setMaxCells(maxCells);
    minLevel && unionCoverer.setMinLevel(minLevel);
    unionCoverer.setMaxLevel(maxLevel);
    const covererUnion = unionCoverer.getCoveringUnion(bounds);
    const s2CellIds = covererUnion.getCellIds();
    iotv_v3_types_1.proxyLogger.info(`shapeCellIdsToCovererCellIds returned ${s2CellIds.length} cellIds`);
    return s2CellIds;
};
exports.shapeCellIdsToCovererCellIds = shapeCellIdsToCovererCellIds;
/** returns cells (and array of lat lng points) covering circle bounds  */
const circleBoundsToCoveringCells = ({ center, radius, units, maxCells, maxLevel, minLevel }) => {
    let cellIds = [];
    const circleBounds = (0, turf_1.circle)((0, TurfUtils_1.gPointToTPosition)(center), radius, { units, steps: 36 });
    const boundsPoints = circleBounds.geometry.coordinates.flat().map(TurfUtils_1.tPositionToGPoint);
    const originLatLng = nodes2ts_1.S2LatLng.fromDegrees(center.lat, center.lng);
    const axis = originLatLng.toPoint();
    const circumferencePoint = nodes2ts_1.S2LatLng.fromDegrees(boundsPoints[0].lat, boundsPoints[0].lng).toPoint();
    const chordAngle = S1ChordAngle_1.S1ChordAngle.fromS2Point(axis, circumferencePoint);
    const s2Cap = new nodes2ts_1.S2Cap(axis, chordAngle);
    const capBounds = s2Cap.getCapBound();
    const unionCoverer = new nodes2ts_1.S2RegionCoverer();
    maxCells && unionCoverer.setMaxCells(maxCells);
    minLevel && unionCoverer.setMinLevel(minLevel);
    unionCoverer.setMaxLevel(maxLevel);
    const covererUnion = unionCoverer.getCoveringUnion(capBounds);
    cellIds = covererUnion.getCellIds();
    const res = { cellIds, boundsPoints };
    return res;
};
exports.circleBoundsToCoveringCells = circleBoundsToCoveringCells;
